<template>
    <div class="about-product__wrap-media" :class="{ 'full-width': isFullWidth }">
        <div class="about-product__slider-container" v-if="!no_video" :class="{ active: sliderVisible }">
            <div class="about-product__video" v-if="product.additional_data?.video || product.additional_data?.videogame">
                <iframe
                    id="youtube-player"
                    ref="videoIframe"
                    :src="`${product?.is_online_game ? product.additional_data.videogame : product.additional_data.video}?enablejsapi=1`"
                    frameborder="0"
                    allow="autoplay"
                    allowfullscreen
                ></iframe>
                <div 
                    class="custom-video-img" 
                    :class="{ active: sliderVisibleImg }" 
                    v-if="videoImg" 
                    @click="playVideo"
                >
                    <img :src="videoImg" :title="product.images.icon_1200x600.title" :alt="product.images.icon_1200x600.alt"/>
                    <span class="custom-video-img__btn">
                        <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10.7425 7.05677C10.6008 6.97276 10.4394 6.92774 10.2747 6.92631C10.1099 6.92487 9.94777 6.96705 9.80462 7.04858C9.66147 7.13011 9.54245 7.24808 9.45965 7.39049C9.37685 7.53291 9.33322 7.6947 9.33319 7.85944V29.4723C9.33322 29.6371 9.37685 29.7989 9.45965 29.9413C9.54245 30.0837 9.66147 30.2017 9.80462 30.2832C9.94777 30.3647 10.1099 30.4069 10.2747 30.4055C10.4394 30.404 10.6008 30.359 10.7425 30.275L28.9783 19.4686C29.1176 19.3859 29.233 19.2685 29.3131 19.1277C29.3932 18.987 29.4354 18.8278 29.4354 18.6659C29.4354 18.5039 29.3932 18.3448 29.3131 18.204C29.233 18.0633 29.1176 17.9459 28.9783 17.8632L10.7425 7.05677Z" fill="white" stroke="white" stroke-width="2.33333" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </span>
                </div>
            </div>
            <div class="about-product__img" v-else>
                <img :src="product?.images?.icon_1200x600.src" :alt="product?.images?.icon_1200x600.alt"/>
            </div>
            <div class="custom-title" :class="{ active: sliderVisible }" v-if="product?.name">
                <div class="custom-title__title">
                    {{ decodeHtmlEntities(product.name) }}
                </div>
            </div>
        </div>
        <div class="about-product__slider-container" v-else>
            <div class="about-product__img">
                <img :src="product?.images?.icon_1200x600.src" :alt="product?.images?.icon_1200x600.alt"/>
            </div>
        </div>
    </div>
</template>

<script>
import { decodeHtmlEntities } from '/webpack-assets/vue/utils/decodeHtmlEntities';

export default {
    props: {
        product: Object,
        isFullWidth: Boolean,
        initSlide: { type: Number, default: 0 },
        no_video: { type: Boolean, default: false }
    },

    data() {
        return {
            sliderVisible: true,
            sliderVisibleImg: true,
            playQueue: false,
            videoIframeReady: false,
            videoImg: null,
            videoTitle: null,
            videoPublisher: null,
        };
    },

    mounted() {
        if (this.product?.additional_data) {
            this.getYouTubeThumbnail();
        }

        if (!window.YT) {
            const tag = document.createElement('script');
            tag.src = "https://www.youtube.com/iframe_api";
            document.body.appendChild(tag);

            window.onYouTubeIframeAPIReady = () => {
                this.createPlayer();
            };
        } else {
            this.createPlayer();
        }
    },

    methods: {
        decodeHtmlEntities,
        createPlayer() {
            if (!window.YT || !window.YT.Player) return;
            this.youTubePlayer = new YT.Player('youtube-player', {
                events: {
                    'onReady': (event) => {
                        this.videoIframeReady = true;
                    },
                    'onStateChange': this.onPlayerStateChange
                }
            });
        },
        playVideo() {
            if (!this.videoIframeReady) return;
            this.sliderVisible = false;
            this.sliderVisibleImg = false;
            const tryPlay = () => {

                if (this.videoIframeReady && this.youTubePlayer.playVideo) {
                    this.youTubePlayer.playVideo();
                } else {
                    setTimeout(tryPlay, 50);
                }
            };

            tryPlay();
        },
        pauseVideo() {
            if (this.youTubePlayer && this.videoIframeReady) {
                this.youTubePlayer.pauseVideo();
            }
        },
        onPlayerStateChange(event) {
            if (event.data === YT.PlayerState.PLAYING) {
                this.sliderVisible = false;
                this.sliderVisibleImg = false;
            } else if (event.data === YT.PlayerState.PAUSED || event.data === YT.PlayerState.ENDED) {
                this.sliderVisible = true;
                this.sliderVisibleImg = true;
            }
        },
        getYouTubeThumbnail() {
            let url = this.product?.is_online_game
                ? this.product.additional_data.videogame
                : this.product.additional_data.video;

            if (!url) return;

            const match = url.match(/(?:v=|embed\/)([a-zA-Z0-9_-]{11})/);
            if (match && match[1]) {
                this.videoImg = `https://img.youtube.com/vi/${match[1]}/maxresdefault.jpg`;
            }
        }
    }
};
</script>


<style lang="scss" scoped>
    .about-product{
        &__img img{
            width: 100%;
        }
        &__wrap {
            @media only screen and (max-width: 1023px) {
                flex-direction: column;
            }            
        }
        &__wrap-media{
            box-shadow: 0px 4px 10px 0px #8585851A;
            border-radius: 16px;
            overflow: hidden;
            position: relative;
            min-width: 780px;
            height: 390px;
            max-width: 50%;
            @media only screen and (max-width: 1919px) {
                min-width: 640px;
                height: 320px;
            }
            @media only screen and (max-width: 1640px) {
                min-width: 540px;
                height: 270px;
            }
            @media only screen and (max-width: 1440px) {
                min-width: 569px;
            }
            @media only screen and (max-width: 1279px) {
                min-width: 467px;
                height: 233px;
                width: 100%;
            }
            @media only screen and (max-width: 1023px) {
                min-width: 100%;
                height: 330px;
                max-width: 100%;
            }
            @media only screen and (max-width: 767px) {
                height: 176px;
            }
            img{
                display: block;
            }
            iframe{
                max-width: 100%;
                width: 100%;
                object-fit: cover;
                height: 390px;
                @media only screen and (max-width: 1919px) {
                    height: 320px;
                }
                @media only screen and (max-width: 1640px) {
                    height: 270px;
                }
                @media only screen and (max-width: 1279px) {
                    height: 233px;
                }
                @media only screen and (max-width: 1023px) {
                    height: 330px;
                }
                @media only screen and (max-width: 767px) {
                    height: 176px;
                }
            }
            &.full-width{
                border-radius: 8px;
            }
            .custom-video-img{
                position: absolute;
                z-index: 1;
                width: 100%;
                height: 100%;
                top: 0;
                left: 0;
                cursor: pointer;
                opacity: 0;
                pointer-events: none;
                transition: 0.3s;
                &.active{
                    opacity: 1;
                    pointer-events: all;
                }
                img{
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 100%;
                    height: auto !important;
                }
                &__btn{
                    box-shadow: 0px 0px 20px 0px #000000B2;
                    background: #4E8AFF;
                    width: 64px;
                    height: 64px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    border-radius: 100%;
                    overflow: hidden;
                    z-index: 1;
                    transform: translate(-50%, -50%);
                    transition: 0.3s;
                    pointer-events: none;
                    @media only screen and (max-width: 767px) {
                        width: 49px;
                        height: 49px;
                    }
                }
            }
            .custom-title {
                cursor: auto;
                width: 100%;
                position: absolute;
                top: 0;
                left: 0;
                background: linear-gradient(180deg, rgba(100, 100, 100, 0.4) 0%, rgba(100, 100, 100, 0) 100%);
                backdrop-filter: blur(5px);
                padding: 15px 30px;
                z-index: 2;
                transition: 0.3s all;
                opacity: 0;
                pointer-events: none;
                @media only screen and (max-width: 767px) {
                    padding: 5px 15px;
                }
                &__title{
                    color: #F6F6F6;
                    font-family: "Avenir-Next-DemiBold", sans-serif;
                    font-size: 14px;
                    font-weight: 400;
                    line-height: 19.6px;
                    text-transform: uppercase;
                    @media only screen and (max-width: 767px) {
                        font-size: 12px;
                        line-height: 14.4px;
                    }
                }
                &__publisher{
                    color: #C0C3C9;
                    font-family: "Avenir-Next", sans-serif;
                    font-size: 14px;
                    font-weight: 400;
                    line-height: 19.6px;
                    @media only screen and (max-width: 767px) {
                        font-size: 12px;
                        line-height: 14.4px;
                    }
                }
                &.active {
                    opacity: 1;
                    pointer-events: all;
                }

                .swiper-pagination-bullet {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 15px 0;
                    margin: 0;
                    width: 100%;
                    height: 100%;
                    cursor: pointer;
                    background: unset;
                    opacity: 1;

                    &:after {
                        content: '';
                        transition: 0.3s;
                        border-radius: 50px;
                        width: 100%;
                        height: 2px;
                        background: rgba(255, 255, 255, 0.7);
                    }

                    &.swiper-pagination-bullet-active {
                        &:after {
                            background: #46ca43;
                        }
                    }
                }
            }
        }
    }
</style>